module.exports = __webpack_public_path__ + "static/media/cover-australia.d1c56789.png";